import {
  LayoutDashboard,
  ListTree,
  CalendarDays,
  LineChart,
  ChartCandlestick,
  Newspaper,
  Settings,
  UserRound,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Only active on an exact match - "/" would otherwise light up on every page. */
  end?: boolean;
}

/** Every page, in menu order: the desktop sidebar and the mobile "More" sheet both list these. */
export const NAV_LINKS: NavItem[] = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/eas", label: "EA List", icon: ListTree },
  { to: "/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/charts", label: "Charts", icon: LineChart },
  { to: "/market", label: "Market", icon: ChartCandlestick },
  { to: "/news", label: "News", icon: Newspaper },
  { to: "/settings", label: "Settings", icon: Settings },
  { to: "/profile", label: "Profile", icon: UserRound },
];

/** The pages that get their own tab in the mobile bottom bar; everything else is under More. */
export const MOBILE_TABS = ["/", "/eas", "/market", "/news"];
